import axios from "@/plugins/axios";
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { BddState } from "./types";

export const actions: ActionTree<BddState, RootState> = {
  async checkContreCode({ state }, codes: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;

    const url = `bo/checkContreCode?id=${userId}&code=${codes.code}&contreCode=${codes.contrecode}`;
    // console.log(url);
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async miseEnRoute({ state }) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;

    const url = `bo/miseEnRoute?id=${userId}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async reindexation() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;

    const url = `bo/reindexationDataBase?id=${userId}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async restoreDataBase({ state }, restaureData: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/restoreDataBase?id=${userId}&src=${restaureData.file}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async isAutobackupActive() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/isAutobackUpActive?id=${userId}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getAutobackupConfig() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/getAutoBackupDataBaseConfig?id=${userId}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async saveAutobackupConfig({ state }, autobackup: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/saveAutoBackupDataBaseConfig?id=${userId}`;
    return axios
      .post(url, autobackup)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async getBackupFiles({ state }, path: string) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/getBackupFiles?id=${userId}&src=${path}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async backup({ state }, restaureData: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const path = restaureData.path + "/" + restaureData.fname + ".backup";
    const url = `bo/backupDataBase?id=${userId}&dest=${path}`;
    try {
      return axios.get(url).then((response) => {
        return response;
      });
    } catch (error) {
      if (error instanceof Error && "response" in error) {
        return Promise.reject(error);
      }
      throw error;
    }
  },
  async emptyPartiel({ state }, param: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/emptyPartialDataBase?id=${userId}&Site=${param.site}&debut=${param.debut}&fin=${param.fin}&commentaire=${param.commentaire}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async empty({ state }, reason: string) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/emptyDataBase?id=${userId}&commentaire=${reason}`;
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};
